// extracted by mini-css-extract-plugin
export var icon = "_4f-1";
export var subtext = "_4f-0";